'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TimePicker = require('./TimePicker');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TimePicker)['default'];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-time-picker/lib/index.js
// module id = 887
// module chunks = 0